<template>
  <div
    class="html_personNameBar"
    ref="html_personNameBar"
    v-if="datas.objectInfo && datas.objectInfo.length === 1"
  >
    <div class="main">
      <span class="themeBg_container"></span>
      <span class="themeVal_container">
        <span class="playerNameList">
          <span
            class="playerName"
            v-for="player in datas.objectInfo[0].playerInfos"
            :key="player.playerId"
            v-text="_valFormatHandler(player.playerName)"
          ></span>
          <!-- <span class="playerName" v-text="'姓名姓名'"></span> -->
        </span>
        <span class="sportsEventName">
          <span
            class="names"
            v-text="
              `${_valFormatHandler(sportsName)}·${_valFormatHandler(eventName)}`
            "
          ></span>
        </span>
        <span class="teamName">
          <span
            class="names"
            v-text="`${_valFormatHandler(datas.objectInfo[0].teamName)}`"
          ></span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
// 人名条
// import htmlDomToImage_base64_data_mixin from '@mixins/htmlDomToImage_base64_data'
export default {
  name: 'html_personNameBar',
  // mixins: [htmlDomToImage_base64_data_mixin],
  props: {
    datas: {
      // 必传参数，球员的所有信息放到一个对象里
      type: Object,
      default: () => ({
        objectInfo: [],
        data: {},
        statisticsModels: [],
      }),
    },
  },
  data() {
    return {}
  },
  created() {
    // 模拟数据
    console.debug(this.datas)
  },
  updated() {
    console.debug(`更新： ${this.datas}`)
  },
  computed: {
    sportsName() {
      let name = ''
      if (this.datas.data && this.datas.data.disciplineName) {
        name = this.datas.data.disciplineName
      }
      return name
    },
    eventName() {
      let name = ''
      if (this.datas.data && this.datas.data.eventName) {
        name = this.datas.data.eventName
      }
      return name
    },
  },
  methods: {
    _valFormatHandler(val, ceil) {
      let data
      // console.debug(val, typeof val)
      if (val === undefined || val === null || val === '' || val === ' ') {
        data = '-'
      } else {
        if (val && ceil) {
          data = `${val}${ceil ? ceil : ''}`
        } else {
        }
        data = val
      }
      // console.debug(val, data)
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
.html_personNameBar {
  width: 100%;
  height: 90%;
  display: flex;
  display: -webkit-flex;
  justify-content: flex-end;
  align-items: center;
  flex-direction: column;
  text-align: left;
  .main {
    position: relative;
    width: 94%;
    overflow: hidden;
    color: var(--mixtmt_whiteColor);

    .themeBg_container {
      display: block;
      width: 100%;
      padding-top: 14.3%;
      background-image: var(--mixtmt_theme_personNameBar_bg);
      background-position: left top;
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .themeVal_container {
      width: 100%;
      display: flex;
      display: -webkit-flex;
      justify-content: center;
      align-items: center;
      .playerNameList {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        width: 32.85%;
        height: 66.66%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        padding: 0 0.55vw;
        .playerName {
          width: 100%;
          font-size: 1.11vw;
          line-height: 1.66vw;
          text-align: left;
        }
      }
      .sportsEventName {
        position: absolute;
        top: 15.38%;
        left: 35%;
        z-index: 10;
        width: 65%;
        height: 58.97%;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        padding: 0 1.38vw 0 2.083vw;
        .names {
          width: 100%;
          font-size: 1.11vw;
          line-height: 1.66vw;
        }
      }
      .teamName {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 10;
        width: 32.85%;
        height: 1.5vw;
        display: flex;
        display: -webkit-flex;
        justify-content: center;
        align-items: center;
        padding: 0 0.972vw;
        .names {
          width: 100%;
          font-size: 0.833vw;
          line-height: 1.5vw;
        }
      }
    }
  }
}
</style>
